// Lightweight image URL optimizer + media resolver.
// Our own media (/api/public/...) is resolved against the CURRENT domain the app is
// served from, so it works on noseyai.app (or any domain) regardless of what host was
// stored or baked in at build time. External URLs (CDN, unsplash, youtube) pass through.
const BACKEND = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

function apiOrigin() {
  if (typeof window !== "undefined" && window.location && window.location.origin) {
    return window.location.origin;
  }
  return BACKEND;
}

export function mediaSrc(url) {
  if (!url || typeof url !== "string") return url;
  if (url.startsWith("data:")) return url;
  const i = url.indexOf("/api/public/");
  if (i >= 0) return apiOrigin() + url.slice(i);
  return url;
}

export function optimizeImg(url, w = 800, q = 70) {
  if (!url || typeof url !== "string") return url;
  if (url.startsWith("data:")) return url;
  url = mediaSrc(url);
  try {
    if (url.includes("unsplash.com")) {
      const u = new URL(url);
      u.searchParams.set("auto", "format");
      u.searchParams.set("fit", "crop");
      u.searchParams.set("w", String(w));
      u.searchParams.set("q", String(q));
      return u.toString();
    }
  } catch (e) {
    return url;
  }
  return url;
}
